module.exports = __webpack_public_path__ + "fe523509b7547b17034d9aec48f57472.svg";